import { Type } from "@angular/core";

// TODO: ?
export type ComponentType = Type<unknown>;
